// SEE projects/ftr-web/src/assets/images/svgs/README.md for instructions on how to add new icons
export const ICONS = {
  AccountBalance: 'account_balance',
  AccountCircle: 'account_circle',
  ActivityLog: 'activity_log',
  Add: 'add',
  AddCircle: 'add_circle',
  AddPerson: 'add_person',
  Agent: 'agent',
  Annotate: 'annotate',
  Apple: 'apple',
  ApproachingDue: 'approaching_due',
  Archive: 'archive',
  ArrowDropDown: 'arrow_drop_down',
  ArrowLeft: 'arrow_left',
  ArrowRight: 'arrow_right',
  Assignment: 'assignment',
  AssignmentReturn: 'assignment_return',
  AssignmentTurnedIn: 'assignment_turned_in',
  AuditLog: 'audit_log',
  Automation: 'automation',
  Autoscroll: 'autoscroll',
  AutoscrollOff: 'autoscroll_off',
  AwaitingApproval: 'awaiting_approval',
  AwaitingFulfillment: 'awaiting_fulfillment',
  BrokenImage: 'broken_image',
  Calendar: 'calendar',
  CardChart: 'card_chart',
  CourtroomCalendar: 'courtroom_calendar',
  Cancel: 'cancel',
  ChangeOrder: 'change_order',
  ChangeOrderDown: 'change_order_down',
  ChangeOrderUp: 'change_order_up',
  CheckCircle: 'check_circle',
  Checkmark: 'checkmark',
  ChevronLeft: 'chevron_left',
  ChevronRight: 'chevron_right',
  Close: 'close',
  Copy: 'copy',
  Courtroom: 'courtroom',
  Courthouse: 'courtroom_participant',
  CourtroomParticipant: 'courtroom_participant',
  CreditCard: 'credit_card',
  Default: 'default',
  Delete: 'delete',
  Departments: 'departments',
  Description: 'description',
  DesktopDeepLink: 'desktop_deep_link',
  DesktopDownload: 'desktop_download',
  DollarSign: 'dollar_sign',
  Domain: 'domain',
  Done: 'done',
  Door: 'door',
  Download: 'download',
  DownloadRecording: 'download_recording',
  DownloadText: 'download_text',
  Drag: 'drag',
  Draggable: 'draggable',
  Duration: 'duration',
  Edit: 'edit',
  Email: 'email',
  Error: 'error',
  ExitFullscreen: 'exit_fullscreen',
  Export: 'export',
  Facebook: 'facebook',
  FiberManualRecord: 'fiber_manual_record',
  FilterList: 'filter_list',
  Folder: 'folder',
  FolderOpen: 'folder_open',
  FolderOpenLive: 'folder_open_live',
  FolderOpenStop: 'folder_open_stop',
  Forward5: 'forward_5',
  Forward30: 'forward_30',
  FootPedal: 'foot_pedal',
  FullScreen: 'full_screen',
  Gavel: 'gavel',
  Global: 'global',
  Google: 'google',
  GoToNext: 'go_to_next',
  HelpCircle: 'help_circle_solid',
  Hearing: 'hearing',
  Historical: 'historical',
  Home: 'home',
  HorizontalBarChart: 'horizontal_bar_chart',
  InProgress: 'in_progress',
  InReview: 'in_review',
  Inactive: 'inactive',
  Info: 'info',
  InfoCircleLine: 'info_circle_line',
  Judge: 'judge',
  Keyboard: 'keyboard',
  KeyboardArrowDown: 'keyboard_arrow_down',
  KeyboardArrowLeft: 'keyboard_arrow_left',
  KeyboardArrowRight: 'keyboard_arrow_right',
  KeyboardArrowUp: 'keyboard_arrow_up',
  LargerView: 'larger_view',
  Lightbulb: 'lightbulb',
  LineChart: 'line_chart',
  Link: 'link',
  LinkOff: 'link_off',
  ListAlt: 'list_alt',
  Livestream: 'livestream',
  LocationOn: 'location_on',
  Lock: 'lock',
  LockLive: 'lock_live',
  LockStop: 'lock_stop',
  Logout: 'logout',
  Menu: 'menu',
  Mic: 'mic',
  MicLive: 'mic_live',
  MicStop: 'mic_stop',
  Microsoft: 'microsoft',
  More: 'more',
  MoreVert: 'more_vert',
  MoveUp: 'move_up',
  MoveDown: 'move_down',
  MultiTrack: 'multi_track',
  MyOrders: 'my_orders',
  OrdersAudio: 'orders_audio',
  OrdersRealtime: 'orders_realtime',
  OrdersTranscript: 'orders_transcript',
  NavigateDown: 'navigate_down',
  NavigateUp: 'navigate_up',
  NoAccess: 'no_access',
  NoEncryption: 'no_encryption',
  NotInSession: 'not_in_session',
  Off: 'off',
  OpenInNew: 'open_in_new',
  OrderTranscript: 'order_transcript',
  PaperPlane: 'paper_plane',
  Pause: 'pause',
  PauseCircleOutline: 'pause_circle_outline',
  People: 'people',
  Person: 'person',
  Phone: 'phone',
  PieChart: 'pie_chart',
  Pin: 'pin',
  PlayArrow: 'play_arrow',
  PlayCircleOutline: 'play_circle_outline',
  PlayerMenu: 'player_menu',
  PlaybackFullscreen: 'playback_full_screen',
  PlaylistPlayBack: 'playlist_play_back',
  RadioButtonSelected: 'radio_button_selected',
  Recorders: 'recorders',
  RecordingVault: 'recording_vault',
  Reload: 'reload',
  RemoteParticipant: 'remote_participant',
  Remove: 'remove',
  RemoveCircle: 'remove_circle',
  Replay5: 'replay_5',
  Replay30: 'replay_30',
  Resubmission: 'resubmission',
  Sandbox: 'sandbox',
  Schedule: 'schedule',
  Search: 'search',
  Sell: 'sell',
  SendToWaitingRoom: 'send_to_waiting_room',
  Settings: 'settings',
  Share: 'share',
  SharedRecordings: 'shared_recordings',
  ShowVideo: 'show_video',
  SmallerView: 'smaller_view',
  Solo: 'solo',
  SplitView: 'split_view',
  SplitView7030: 'split_view_70_30',
  SplitView3070: 'split_view_30_70',
  StopCircle: 'stop_circle',
  Storage: 'storage',
  SubArrowRight: 'sub_arrow_right',
  Table: 'table_chart',
  Timezone: 'timezone',
  Transcriber: 'transcriber',
  Transcript: 'transcript',
  TranscriptJobs: 'transcript_jobs',
  TranscriptOutline: 'transcript_outline',
  Translate: 'translate',
  TrmRepositories: 'trm_repositories',
  Unlock: 'unlock',
  Unpin: 'unpin',
  Upload: 'upload',
  UploadAndPlay: 'upload_and_play',
  UserAccess: 'user_access',
  VerifiedUser: 'verified_user',
  VerticalBarChart: 'vertical_bar_chart',
  VideoCam: 'videocam',
  VideoCamOff: 'videocam_off',
  Visibility: 'visibility',
  VisibilityOff: 'visibility_off',
  VolumeDown: 'volume_down',
  VolumeOff: 'volume_off',
  VolumeUp: 'volume_up',
  Warning: 'warning',
  Waveform: 'waveform',
  WaveformOff: 'waveform_off',
  Work: 'work',
  CourtMonitoring: 'realtime_monitoring',
} as const
export type Icon = keyof typeof ICONS

export enum CardIcon {
  Amex = 'amex',
  AmexGrey = 'amex_grey',
  Diners = 'diners',
  DinersGrey = 'diners_grey',
  Discover = 'discover',
  DiscoverGrey = 'discover_grey',
  EmptyCard = 'empty_card',
  Jcb = 'jcb',
  JcbGrey = 'jcb_grey',
  Mastercard = 'mastercard',
  MastercardGrey = 'mastercard_grey',
  Visa = 'visa',
  VisaGrey = 'visa_grey',
}
